import { render, staticRenderFns } from "./SearchTotalResultDescription.vue?vue&type=template&id=19d6e5cb&scoped=true&"
import script from "./SearchTotalResultDescription.vue?vue&type=script&lang=js&"
export * from "./SearchTotalResultDescription.vue?vue&type=script&lang=js&"
import style0 from "./SearchTotalResultDescription.vue?vue&type=style&index=0&id=19d6e5cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d6e5cb",
  null
  
)

export default component.exports